export const calendarOverrideStyles = (theme='dark')=>{
  return  `
  .candidate-analytics-calendar .react-calendar {
    border: none !important;
    background: ${theme === 'dark' ? "#0a1733 !important" : "#fff !important"};
    padding: 0 !important;
  }
  .candidate-analytics-calendar .platform-calendar {
    width: 340px !important;
    padding: 10px !important;
  }
  .candidate-analytics-calendar .react-calendar__tile {
    padding: 8px 0 !important;
    height: 34px !important;
    font-size: 13px !important;
  }
  .candidate-analytics-calendar .react-calendar__navigation__label {
    font-size: 16px !important;
  }
  .candidate-analytics-calendar .react-calendar__month-view__weekdays {
    font-size: 11px !important;
    margin-bottom: 8px !important;
  }
  .candidate-analytics-calendar .react-calendar__month-view__days .react-calendar__tile--now::before {
    width: 34px !important;
    height: 34px !important;
  }
  .candidate-analytics-calendar .react-calendar__month-view__days .react-calendar__tile--active::before,
  .candidate-analytics-calendar .react-calendar__month-view__days .react-calendar__tile--range::before {
    width: 32px !important;
    height: 32px !important;
  }
  .candidate-analytics-calendar .react-calendar__month-view__days .react-calendar__tile:enabled:hover::before {
    width: 32px !important;
    height: 32px !important;
  }
  .candidate-analytics-calendar .react-calendar__year-view__months__month,
  .candidate-analytics-calendar .react-calendar__decade-view__years__year {
    padding: 24px 8px !important;
    height: 70px !important;
  }
`;

}